import { CreateCampaignRequest } from '@app/models/requests';
import { CampaignPageDesignsResponseInterface } from '@app/models/campaigns';
import { apiInstance } from './api';
import { ApiRoutes } from './consts';

export const createCampaign = async (data: CreateCampaignRequest) => {
  return apiInstance.post(`${ApiRoutes.Campaigns}/create`, data);
};

export const getCampaigns = async ({
  page,
  limit,
  sortBy,
  sortOrder,
  statuses,
  channels,
  platforms,
  scheduled,
  from,
  to,
  name,
}: {
  page: number;
  limit: number;
  sortBy: string | undefined;
  sortOrder: string;
  statuses?: string[];
  channels?: string[];
  platforms?: string[];
  scheduled?: boolean;
  from?: string;
  to?: string;
  name?: string;
}) => {
  // Build params object manually to avoid array serialization issues
  const params: any = {
    page,
    limit,
    sortBy,
    sortOrder,
    scheduled,
    from,
    to,
    name,
  };

  // Handle statuses parameter - send as array
  if (statuses && statuses.length > 0) {
    params.statuses = statuses;
  }

  // Handle channels parameter
  if (channels && channels.length > 0) {
    if (channels.length === 1) {
      params.channels = channels[0];
    } else {
      params.channels = channels;
    }
  }

  // Handle platforms parameter
  if (platforms && platforms.length > 0) {
    if (platforms.length === 1) {
      params.platforms = platforms[0];
    } else {
      params.platforms = platforms;
    }
  }

  return apiInstance.get(`${ApiRoutes.Campaigns}/`, {
    params,
  });
};

export const getCampaign = async (id: string) => {
  return apiInstance.get(`${ApiRoutes.Campaigns}/${id}`);
};

export const updateCampaign = async (
  id: string,
  data: Partial<CreateCampaignRequest>
) => {
  return apiInstance.put(`${ApiRoutes.Campaigns}/${id}`, data);
};

export const cancelCampaign = async (id: string) => {
  return apiInstance.post(`${ApiRoutes.Campaigns}/${id}/cancel`);
};


export const deleteCampaign = async (id: string) => {
  return apiInstance.delete(`${ApiRoutes.Campaigns}/${id}`);
};

export const cloneCampaign = async (id: string, status: string = 'DRAFT') => {
  return apiInstance.post(`${ApiRoutes.Campaigns}/${id}/clone`, { status });
};

export const addCustomerToCampaign = async (
  campaignId: string,
  customerId: string
) => {
  return apiInstance.post(
    `${ApiRoutes.Campaigns}/${campaignId}/customers/${customerId}`
  );
};

export const addScheduleToCampaign = async (
  campaignId: string,
  data: {
    startDate: string;
    frequency?: string;
    time?: string;
  }
) => {
  return apiInstance.post(
    `${ApiRoutes.Campaigns}/${campaignId}/schedules`,
    data
  );
};

export const getFutureSchedules = async () => {
  return apiInstance.get(`${ApiRoutes.Campaigns}/schedules/future`);
};

export const getCampaignPageDesigns = async (campaignId: string, accessToken: string, businessId: string): Promise<{ data: CampaignPageDesignsResponseInterface }> => {
  const headers: Record<string, string> = {};
  if (accessToken && businessId) {
    headers['Authorization'] = `Bearer ${accessToken}`;
    headers['echo-business-id'] = businessId;
  }
  
  return apiInstance.get(`/campaign-designs/campaigns/${campaignId}/page-designs`, {
    headers
  });
};
